// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import HomeRoute from './routes/HomeRoute';
import CreateQuestionRoute from './routes/CreateQuestionRoute';
import QuestionRoute from './routes/QuestionRoute';
import MatchRoute from './routes/MatchRoute';
import MyMatchesRoute from './routes/MyMatchesRoute';
import NotFound from './components/NotFound/NotFound';
import ProfileRoute from './routes/ProfileRoute';
import ImprintRoute from './routes/ImprintRoute';

@inject('componentStore')
@observer class PageRouter extends Component<any, any> {

    componentDidMount() {
        this.props.history.listen((location: any, action: any) => {
            this.props.componentStore.nav = false;
        });
    }
    
    render() {
        return (
            <main>
                <Switch>
                    <Route exact path="/" component={HomeRoute} />
                    <Route exact path="/create-question" component={CreateQuestionRoute} />
                    <Route exact path="/matches" component={MyMatchesRoute} />
                    <Route exact path="/profile" component={ProfileRoute} />
                    <Route exact path="/imprint" component={ImprintRoute} />
                    <Route path="/question/:id" component={QuestionRoute} />
                    <Route path="/match/:id" component={MatchRoute} />
                    <Route component={NotFound} />
                </Switch>
            </main>
        );
    }
}

export default withRouter(PageRouter);
